import './style/index.js';

import _TreeSelect from './TreeSelect';

export type { TreeSelectProps } from './TreeSelect';
export * from './type';

export const TreeSelect = _TreeSelect;
export default TreeSelect;
